<template>
  <span
    >{{ actionStyling[action._type].description }} '{{
      action.label.substring(0, 35)
    }}'</span
  >
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      actionStyling: "automations/actionStyling",
    }),
  },
  async mounted() {},
};
</script>

<style lang="scss">
</style>